export const pickupTypes = Object.freeze({
  PICKUP: { key: 'pickup', paramName: 'pickup' },
  GO_HOME_WITH: { key: 'go_home_with', paramName: 'goHomeWith' },
  SELF_DECIDER: { key: 'self_decider', paramName: 'selfDecider' },
  SEND_HOME: { key: 'send_home', paramName: 'sendHome' },
});
